import React from 'react';
const benefits = ['Actividades prácticas y listas para usar', 'Aplicable a distintas materias', 'Pensado especialmente para adolescentes', '8 habilidades esenciales en un solo material'];
export function HeroSection() {
  return <section className="pt-12 pb-4 px-4 bg-white text-center" data-id="element-62" data-mp="23wcxdyn0k2jv">
      <div className="max-w-4xl mx-auto" data-id="element-63" data-mp="28tmkv8que452">
        <p className="md:text-xs text-gray-400 tracking-wider mb-4 text-[12px] font-[600] font-[Figtree,_sans-serif]" data-id="element-64" data-mp="28uo7mah80f2m">
          "Un material práctico para trabajar habilidades que tus estudiantes
          necesitan dentro y fuera del aula"
        </p>

        <h1 className="text-3xl md:text-5xl font-black mb-1 leading-tight tracking-tight" data-id="element-65" data-mp="2mufiw3gcrhcx">
          <span className="px-2 text-[#1B3A6B] bg-[#FFFFFF] text-[24px]" data-id="element-66" data-mp="2rsqtwhidvxwq">
            8 HABILIDADES PARA SECUNDARIA
          </span>
        </h1>

        

        <div className="block max-w-[600px] mx-auto mb-3" data-id="element-67" data-mp="3fha08rhvi0m6">
          <img src="https://cdn.magicpatterns.com/uploads/oqQ5tJksQY6ihcLkMfq1Ex/IMAGEN_PRINCIPAL.png" alt="8 Habilidades para Secundaria — 116 páginas de actividades listas para usar" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-68" data-mp="3k9jlhu81mci4" />
        </div>

        <div className="text-lg md:text-xl mb-4 text-gray-700 space-y-2 max-w-3xl mx-auto font-medium" data-id="element-69" data-mp="2p5blkp28dcrn">
          <p className="text-[14px]" data-id="element-70" data-mp="2kelen7e5p1uu">
            Actividades listas para desarrollar comprensión lectora, escritura, técnicas de estudio, pensamiento crítico, orientación vocacional, argumentación e inteligencia artificial.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 mb-5" data-id="element-71" data-mp="2u3wmyrt7y2ho">
          <span className="text-lg font-bold text-gray-400 line-through" data-id="element-72" data-mp="3834rm085i2t9">
            ARS $39.990
          </span>
          <span className="bg-red-600 text-white text-xs font-black px-2.5 py-1 rounded-full" data-id="element-73" data-mp="335medxn3p1fg">
            50% OFF
          </span>
          <span className="text-3xl font-black text-[#1B3A6B]" data-id="element-74" data-mp="1drzqb2kje2h3">$19.990</span>
        </div>

        <div className="bg-[#EEF7F8] rounded-2xl p-5 max-w-md mx-auto border border-[#B8E0E4]" data-id="element-75" data-mp="18t6dlcd2qfhz">
          <p className="text-lg font-black text-gray-900 mb-3" data-id="element-76" data-mp="38vfnl000ei0x">
            👉 Beneficios del material
          </p>
          <div className="space-y-2 text-left" data-id="element-77" data-mp="3irindz7e24kp">
            {benefits.map(benefit => <p key={benefit} className="text-base font-semibold text-gray-800 flex items-start" data-id="element-78" data-mp="3iq7ke1lrp0un">
                <span className="text-green-600 mr-2 text-lg leading-none mt-0.5" data-id="element-79" data-mp="3mufc87niuwx3">
                  ✔️
                </span>
                {benefit}
              </p>)}
          </div>
        </div>
      </div>
    </section>;
}